export const publicComments = () => {
	const commentToggles = document.querySelectorAll('.wp-block-custom .public-comment .btn');

	// If .public comment only has one paragraph and class .is-short
	const comments = document.querySelectorAll('.wp-block-custom .public-comment');
	comments.forEach((comment) => {
		const paragraphs = comment.querySelectorAll('p');
		if (paragraphs.length <= 1) {
			comment.classList.add('is-short');
		}
	});

	commentToggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const commentContainer = toggle.closest('.public-comment');
			const isExpanded = commentContainer.classList.toggle('is-open');

			// Update the button text and ARIA attributes
			toggle.textContent = isExpanded ? toggle.getAttribute('data-less-label') : toggle.getAttribute('data-more-label');
			toggle.setAttribute('aria-expanded', isExpanded);

			// Optionally, adjust ARIA attributes on the commentContainer if needed
			commentContainer.setAttribute('aria-hidden', !isExpanded);
		});
	});
};
